import MessageThreadActions from './MessageThreadActions';

export default MessageThreadActions;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadActions/index.js